interface TransactionErrorSlice {
    transactionErrorMessage: string | null;
    transactionErrorType: 'error' | 'warning' | 'info';
    isTransactionErrorVisible: boolean;
    setTransactionError: (
        message: string,
        type?: 'error' | 'warning' | 'info',
        duration?: number
    ) => void;
    clearTransactionError: () => void;
    toggleTransactionErrorVisibility: () => void;
}

const createTransactionErrorSlice = (set: any): TransactionErrorSlice => ({
    transactionErrorMessage: null,
    transactionErrorType: 'error',
    isTransactionErrorVisible: false,
    setTransactionError: (
        message: string,
        type: 'error' | 'warning' | 'info' = 'error',
        duration: number = 5000
    ) => {
        set(() => ({
            transactionErrorMessage: message,
            transactionErrorType: type,
            isTransactionErrorVisible: true,
        }));
        setTimeout(() => {
            set(() => ({
                transactionErrorMessage: null,
                isTransactionErrorVisible: false,
            }));
        }, duration);
    },
    clearTransactionError: () =>
        set(() => ({
            transactionErrorMessage: null,
            isTransactionErrorVisible: false,
        })),
    toggleTransactionErrorVisibility: () =>
        set((state: TransactionErrorSlice) => ({
            isTransactionErrorVisible: !state.isTransactionErrorVisible,
        })),
});

export { createTransactionErrorSlice };
export type { TransactionErrorSlice };
